// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__us8qB","row":"Form_row__2Hpkq","footer":"Form_footer__1mKpq","divider":"Form_divider__2Y78R"};